import { RootState } from '@app/redux/root-reducer';

export const selectAddLeaveManagementState = (store: RootState) =>
  store.leaveManagementReducer.addLeaveManagement;
export const selectLeaveManagementState = (store: RootState) =>
  store.leaveManagementReducer.leaveManagement;
export const selectUpdateLeaveManagementStatusState = (store: RootState) =>
  store.leaveManagementReducer.updateLeaveManagementStatus;
export const selectDeleteLeaveManagementState = (store: RootState) =>
  store.leaveManagementReducer.deleteLeaveManagement;
export const selectUpdateLeaveManagementState = (store: RootState) =>
  store.leaveManagementReducer.updateLeaveManagement;
